export default __webpack_public_path__ + "static/media/13.21bebe2d.png";